import React from 'react';

export const AdultsOnlyPaizuriIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M31.34 45.5599C26.34 45.5599 22.28 41.4999 22.28 36.4999C22.28 31.4999 26.34 27.4399 31.34 27.4399C36.34 27.4399 40.4 31.4999 40.4 36.4999C40.4 41.4999 36.34 45.5599 31.34 45.5599ZM31.34 31.4399C28.54 31.4399 26.28 33.6999 26.28 36.4999C26.28 39.2999 28.54 41.5599 31.34 41.5599C34.14 41.5599 36.4 39.2999 36.4 36.4999C36.4 33.6999 34.12 31.4399 31.34 31.4399Z"
        fill="#007FB5"
      />
      <path d="M33.3401 13.0798H29.3401V29.4398H33.3401V13.0798Z" fill="#007FB5" />
      <path
        d="M37.2001 20.8999L31.3401 15.7399L25.4601 20.8999L22.8201 17.8999L31.3401 10.4199L39.8401 17.8999L37.2001 20.8999Z"
        fill="#007FB5"
      />
      <path
        d="M31.96 46.1998C26.96 46.1998 22.9 42.1398 22.9 37.1398C22.9 32.1398 26.96 28.0798 31.96 28.0798C36.96 28.0798 41.02 32.1398 41.02 37.1398C41.02 42.1398 36.96 46.1998 31.96 46.1998ZM31.96 32.0798C29.16 32.0798 26.9 34.3398 26.9 37.1398C26.9 39.9398 29.16 42.1998 31.96 42.1998C34.76 42.1998 37.02 39.9398 37.02 37.1398C37.02 34.3398 34.76 32.0798 31.96 32.0798Z"
        fill="#00A6ED"
      />
      <path d="M33.9601 13.7197H29.9601V30.0797H33.9601V13.7197Z" fill="#00A6ED" />
      <path
        d="M37.8401 21.5398L31.9601 16.3798L26.1001 21.5398L23.4601 18.5398L31.9601 11.0598L40.4801 18.5398L37.8401 21.5398Z"
        fill="#00A6ED"
      />
      <path
        d="M6.29999 30.9399C4.27999 32.5399 4.67999 39.1599 5.23999 41.8199C5.75999 44.2199 8.43999 48.4999 10.04 50.1399C14.92 55.1799 27.46 53.1999 30.74 46.5599C31.02 45.9799 31.06 44.4599 30.74 43.8799C28.74 40.1599 21.6 35.3999 18 33.6399C15.28 32.2999 8.71999 29.0399 6.29999 30.9599V30.9399Z"
        fill="#C13870"
      />
      <path
        d="M56.9999 30.9399C59.0199 32.5399 58.6199 39.1599 58.0599 41.8199C57.5399 44.2199 54.8999 48.5399 53.2599 50.1399C48.6399 54.6999 36.0999 52.9599 32.5599 46.5599C32.2399 45.9999 32.2399 44.4599 32.5599 43.8799C34.5599 40.1599 41.6999 35.3999 45.2999 33.6399C48.0399 32.2999 54.5799 29.0399 56.9999 30.9599V30.9399Z"
        fill="#C13870"
      />
      <path
        d="M6.29999 30.9399C4.27999 32.5399 4.67999 39.1599 5.23999 41.8199C5.75999 44.2199 7.97999 49.1199 10.04 50.1399C14.82 52.4999 27.34 50.9199 30.74 46.5599C31.14 46.0399 31.06 44.4599 30.74 43.8799C28.74 40.1599 21.6 35.3999 18 33.6399C15.28 32.2999 8.71999 29.0399 6.29999 30.9599V30.9399Z"
        fill="#FF6AA0"
      />
      <path
        d="M8.14001 32.2199L6.26001 31.6799C6.26001 31.6799 7.74001 29.6599 7.74001 22.0599C7.74001 16.6399 7.32001 17.4399 7.32001 17.3599L9.20001 16.8599C9.26001 17.1399 9.68001 16.3999 9.68001 22.0599C9.68001 29.9399 8.20001 31.9599 8.14001 32.2199Z"
        fill="#FF6AA0"
      />
      <path
        d="M57 30.9399C59.02 32.5399 58.62 39.1599 58.06 41.8199C57.54 44.2199 55.32 49.1199 53.26 50.1399C48.48 52.4999 35.96 50.9199 32.56 46.5599C32.16 46.0399 32.24 44.4599 32.56 43.8799C34.56 40.1599 41.7 35.3999 45.3 33.6399C48.04 32.2999 54.58 29.0399 57 30.9599V30.9399Z"
        fill="#FF6AA0"
      />
      <path
        d="M55.16 32.22L57.04 31.68C57.04 31.68 55.56 29.66 55.56 22.06C55.56 16.64 55.78 17.28 55.8 17.22L53.92 16.72C53.86 17 53.62 16.4 53.62 22.06C53.62 29.94 55.1 31.96 55.16 32.22Z"
        fill="#FF6AA0"
      />
      <path d="M32.68 44.52H30.62V45.96H32.68V44.52Z" fill="#FF6AA0" />
    </svg>
  );
};
